<template>
  <div>
    <div class="pa-4 text-center" v-show="loading">
      <v-progress-circular indeterminate></v-progress-circular>
    </div>

    <div class="d-flex justify-end mr-4 mt-4">
      <v-btn
        v-show="!loading"
        depressed
        small
        @click="printDocument"
        class="white black--text d-print-none"
      >
        <v-icon left>
          mdi-printer
        </v-icon>
        {{ $t("toPrint") }}
      </v-btn>
    </div>

    <div class="ma-4" ref="document" />
  </div>
</template>
<script>
export default {
  data: () => ({
    loading: true,
  }),
  mounted() {
    this.$axios
      .post(
        "/main/responsibleGamblingDocument",
        this.$formdata({ domain: this.$domain() })
      )
      .then((res) => {
        if (this.$refs.document) {
          this.$refs.document.innerHTML = res.data.dados.texto;
        }
      })
      .catch((e) => {
        this.$store.commit("setNotification", {
          msg: e.response.data.messages.error,
          color: "warning",
        });
      })
      .finally(() => (this.loading = false));
  },
  methods: {
    printDocument() {
      this.$printDocument(this.$refs.document.innerHTML);
    },
  },
};
</script>
